/**
 *  Collapsible rows A/B test
 *  Group 2 (body.ab-group-2): all Collapsible row blocks start closed
 *  Group 3 (body.ab-group-3): first Collapsible row uses Read more truncation
 */
(function () {
  const GROUP_2 = 'ab-group-2';
  const GROUP_3 = 'ab-group-3';
  const ROOT_SELECTOR = '.product-information--collapsible-ab';
  const EXPAND_DURATION = 400;
  const SHRINK_DURATION = 250;

  if (window.__collapsibleRowsAbBound) return;
  window.__collapsibleRowsAbBound = true;

  class CollapsibleRowsAb {
    constructor(root) {
      this.root = root;
      this.rows = root.querySelectorAll('.product__accordion--ab-test');
      this.firstRow = root.querySelector('.product__accordion--ab-first');
      this.clamp = this.firstRow ? this.firstRow.querySelector('.collapsible__content--ab-clamp') : null;
      this.button = this.firstRow ? this.firstRow.querySelector('.collapsible-ab-read-more') : null;
      this.detailsFirst = this.firstRow ? this.firstRow.querySelector('details') : null;
      this.appliedGroup2 = false;
      this.isAnimating = false;
      this.animation = null;

      if (this.button) {
        this.button.addEventListener('click', (event) => this.onReadMoreClick(event));
      }
      if (this.detailsFirst) {
        this.detailsFirst.addEventListener('toggle', () => this.updateReadMore());
      }
      if (this.clamp && typeof ResizeObserver !== 'undefined') {
        this.resizeObserver = new ResizeObserver(() => {
          if (this.isAnimating) return;
          this.updateReadMore();
        });
        this.resizeObserver.observe(this.clamp);
      }

      this.apply();
    }

    isGroup2() {
      return document.body.classList.contains(GROUP_2);
    }

    isGroup3() {
      return document.body.classList.contains(GROUP_3);
    }

    apply() {
      if (this.isGroup2()) {
        this.closeAll();
        this.appliedGroup2 = true;
      } else if (this.appliedGroup2) {
        this.restoreAll();
        this.appliedGroup2 = false;
      }

      this.updateReadMore();
    }

    closeAll() {
      this.rows.forEach((row) => {
        const details = row.querySelector('details');
        if (!details) return;
        details.open = false;
        details.style.height = '';
        details.style.overflow = '';
      });
    }

    restoreAll() {
      this.rows.forEach((row) => {
        const details = row.querySelector('details');
        if (!details) return;
        details.open = details.dataset.abDefaultOpen === 'true';
        details.style.height = '';
        details.style.overflow = '';
      });
    }

    onReadMoreClick(event) {
      event.preventDefault();
      event.stopPropagation();
      if (!this.firstRow || !this.button || !this.clamp || this.isAnimating) return;

      this.animateReadMore(!this.firstRow.classList.contains('is-ab-expanded'));
    }

    getClampedHeight() {
      if (!this.firstRow.classList.contains('is-ab-expanded')) {
        return this.clamp.offsetHeight;
      }

      const lines = window.matchMedia('(min-width: 768px)').matches ? 6 : 4;
      const clone = this.clamp.cloneNode(true);
      clone.setAttribute('aria-hidden', 'true');
      clone.style.cssText = [
        'position: absolute',
        'visibility: hidden',
        'pointer-events: none',
        'display: -webkit-box',
        '-webkit-box-orient: vertical',
        `-webkit-line-clamp: ${lines}`,
        'overflow: hidden',
        `width: ${this.clamp.offsetWidth}px`,
        'height: auto',
        'margin: 0'
      ].join(';');
      this.clamp.parentNode.appendChild(clone);
      const height = clone.offsetHeight;
      clone.remove();
      return height;
    }

    animateReadMore(expand) {
      if (this.animation) {
        this.animation.cancel();
      }

      const startHeight = this.clamp.offsetHeight;
      this.isAnimating = true;
      this.firstRow.classList.add('is-ab-animating');
      this.clamp.style.overflow = 'hidden';
      this.clamp.style.height = `${startHeight}px`;

      if (expand) {
        this.firstRow.classList.add('is-ab-expanded');
      }

      const endHeight = expand ? this.clamp.scrollHeight : this.getClampedHeight();

      this.button.setAttribute('aria-expanded', expand ? 'true' : 'false');
      this.button.classList.add('is-visible');

      this.animation = this.clamp.animate({
        height: [`${startHeight}px`, `${endHeight}px`]
      }, {
        duration: expand ? EXPAND_DURATION : SHRINK_DURATION,
        easing: expand ? 'ease-out' : 'ease'
      });

      this.animation.onfinish = () => this.onReadMoreAnimationFinish(expand);
      this.animation.oncancel = () => {
        this.isAnimating = false;
      };
    }

    onReadMoreAnimationFinish(expand) {
      this.animation = null;
      this.isAnimating = false;
      this.clamp.style.height = '';
      this.clamp.style.overflow = '';
      this.firstRow.classList.remove('is-ab-animating');

      if (!expand) {
        this.firstRow.classList.remove('is-ab-expanded');
      }

      this.updateReadMore();
    }

    updateReadMore() {
      if (!this.firstRow || !this.clamp || !this.button || this.isAnimating) return;

      if (!this.isGroup3()) {
        this.button.classList.remove('is-visible');
        this.firstRow.classList.remove('is-ab-expanded', 'is-ab-animating');
        this.button.setAttribute('aria-expanded', 'false');
        return;
      }

      if (this.firstRow.classList.contains('is-ab-expanded')) {
        this.button.classList.add('is-visible');
        this.button.setAttribute('aria-expanded', 'true');
        return;
      }

      const overflowing = this.clamp.scrollHeight > this.clamp.clientHeight + 1;
      this.button.classList.toggle('is-visible', overflowing);
    }
  }

  const instances = new Map();

  function bindRoots() {
    document.querySelectorAll(ROOT_SELECTOR).forEach((root) => {
      if (instances.has(root)) return;
      instances.set(root, new CollapsibleRowsAb(root));
    });
  }

  function applyAll() {
    instances.forEach((instance) => instance.apply());
  }

  bindRoots();

  const bodyObserver = new MutationObserver(applyAll);
  bodyObserver.observe(document.body, {
    attributes: true,
    attributeFilter: ['class']
  });

  document.addEventListener('shopify:section:load', bindRoots);
})();
